export enum DealRejectionReasonType {
  ClientDecision = 1,
  TimeForNegotiationExpired = 2,
  AnotherSpecialistIsSelectedForVacancyOrVacancyIsNoLongerRelevant = 3,
  AnotherDealWithOverlappedDateRangeIsAcceptedBySpecialist = 4,
  ClientIsDeleted = 5,
  ClientIsBanned = 6,
}
